/**
 * Component - gridTopBanner
 */

export const gridTopBanner = ():void => {
  // Check if the Tiny Slider is loaded on the window object or not
  // @ts-ignore
  if (!window.tns) {
    return
  }

  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-gridTopBanner') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {
    const sliderWrapper = component.querySelector('.js-gridTopBanner-slider') as HTMLElement

    // Run only if the actual slider wrapper exists
    if (sliderWrapper) {
      const sliderControlsWrapper = component.querySelector('.js-gridTopBanner-controlsWrapper') as HTMLElement
      const sliderControls: HTMLElement[] = Array.from(component.querySelectorAll('.js-gridTopBanner-controlsSingle'))

      // Set up the slider
      const TNS_object = tns({
        container: sliderWrapper,
        items: 1,
        slideBy: 'page',
        loop: true,
        controls: false,
        autoHeight: false,
        mouseDrag: true,
        swipeAngle: false,
        nav: false,
        prevButton: false,
        nextButton: false,
        autoplay: true,
        autoplayTimeout: 10000
      })

      // Bother with this only if the controls actually exist
      if (sliderControlsWrapper) {
        // General manager for the class switching
        const manageControlsClasses = (key: number) => {
          sliderControls.forEach((single) => {
            single.classList.remove('-active')
          })
          sliderControls[key].classList.add('-active')
        }

        // React to changes on the actual slider object and its currently active index
        TNS_object.events.on('indexChanged', () => {
          const info = TNS_object.getInfo()
          let currentSlideIndex = info.displayIndex - 1
          manageControlsClasses(currentSlideIndex)
        })

        // Hook in the external control buttons for the slider
        sliderControls.forEach((singleControl: HTMLElement, key) => {
          singleControl.addEventListener('click', () => {
            TNS_object.goTo(key)
            manageControlsClasses(key)
          })
        })
      }
    }
  })
}
